module.exports = __webpack_public_path__ + "img/navi_menu.fc0e7259.svg";